export function getEnvironmentLabel(stage: string | undefined, t: (key: string) => string): string {
  if (stage === 'production') return t('Production')
  if (stage === 'staging') return t('Staging')
  return t('Local development')
}

export function getActiveContextSubTextList(
  { systemName, isPreview, stage }: { systemName: string; isPreview: boolean; stage: string | undefined },
  t: (key: string, values?: Record<string, string>) => string
): string[] {
  const systemLine = isPreview
    ? t('System: {{name}} (preview system)', { name: systemName })
    : t('System: {{name}}', { name: systemName })

  return [systemLine, `${t('Environment')}: ${getEnvironmentLabel(stage, t)}`]
}
